<template>
    <div>
        <MenuProducts/>
        <Product_NonPrice/>
    </div>
</template>

<script>
    import MenuProducts from "@/components/admin/manage_products/menuproducts/MenuProducts.vue";
    import Product_NonPrice from "@/components/admin/manage_products/Product_NonPrice.vue";
    export default {
        name: "ProductNonPrice",
        components: {
            Product_NonPrice,
            MenuProducts
        }
    }
</script>

<style scoped>

</style>
